import { InputField } from "@jutro/legacy/components";
import { useRef, useEffect } from "react";

function MakeEditInput({
    row,
    editActions,
    specialityTableConfig,
    updateSubmissionVMOnBlur,
    setSpecialityTableConfig,
    modelKey
}) {
    const wrapperRef = useRef(null);

    const shouldFocus =
        specialityTableConfig?.editedRow === row?.publicID &&
        specialityTableConfig?.focusTarget?.field === modelKey

    useEffect(() => {
        if (shouldFocus) {
            setTimeout(() => wrapperRef.current?.querySelector('input').focus(), 0);
        }
    }, [shouldFocus]);

    const commitAndClose = () => {
        if (!row || !editActions) {
            return;
        }
        const inputEl = wrapperRef.current?.querySelector("input");
        const updatedValue = inputEl?.value ?? "";
        editActions.update(row, modelKey, updatedValue);
        if (row?.publicID) {
            updateSubmissionVMOnBlur(row?.publicID, updatedValue, modelKey);
        }
        setSpecialityTableConfig((prev) => ({
            ...prev,
            editedRow: undefined,
            focusTarget: undefined,
        }));
    };

    const onEditMakeKeyDown = (e) => {
        if (e.key === "Enter") {
           commitAndClose()
        }
    }

    if (!row) {
        return null;
    }

    return (
        <div ref={wrapperRef} onKeyDownCapture={onEditMakeKeyDown}>
            <InputField
                type="text"
                value={row?.[modelKey]}
                onValueChange={(value, _path) => {
                    editActions.update(row, modelKey, value)
                }}
                onBlur={(e) => {
                    const next = e.target.value;
                    if (row?.publicID) {
                        updateSubmissionVMOnBlur(row?.publicID, next, modelKey)
                    }
                    const nextFocusedEl = e.relatedTarget;
                    const editedRowEl = e.target.closest("[class*='editedRow']");
                    if (!nextFocusedEl || !editedRowEl || !editedRowEl?.contains(nextFocusedEl)) {
                        setTimeout(() => {     
                            setSpecialityTableConfig((prev) => ({
                                ...prev,
                                editedRow: undefined,
                            }))
                        }, 0);
                    }
                }}
            />
        </div>
    );
}

export default MakeEditInput